import { Box } from '@gemini/core';
import { InfoState } from '@gemini/ui';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';

import { NAME_SPACE } from '@/frontend/src/hooks/useLoadTranslations';

const ErrorFallback = () => {
    const { t } = useTranslation(NAME_SPACE);

    return (
        <Box
            display="flex"
            justifyContent="center"
            paddingHorizontal="spacing.16"
        >
            <InfoState
                title={t('common.infoState.serverError.title')}
                description={t('common.infoState.serverError.message')}
                startButtonProps={{
                    children: t('common.infoState.button.refresh') as 'string',
                    onPress: () => {
                        // reset the entire application from a clean state
                        window.location.reload();
                    },
                }}
            />
        </Box>
    );
};

export default ErrorFallback;
